'use client'

import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import { ArrowDownUp, Globe, Percent, TrendingUp, Wallet, Zap } from 'lucide-react'

const features = [
  {
    icon: Zap,
    title: 'Real-Time Credit',
    description:
      'No pre-loading. No stablecoin off-ramps. Your card borrows against your collateral at the moment of purchase.',
  },
  {
    icon: Wallet,
    title: 'On-Chain Always',
    description: 'Your assets stay on-chain, under your control. Always.',
  },
  {
    icon: Globe,
    title: 'Anywhere Visa Is Accepted',
    description: 'Use your card at over 150 million merchants, online and in-store, anywhere Visa is accepted.',
  },
  {
    icon: ArrowDownUp,
    title: 'No Top-Ups Required',
    description: 'Forget loading cards or converting to fiat first. Tap and spend directly against your holdings.',
  },
  {
    icon: TrendingUp,
    title: 'Never Sell to Spend',
    description: 'Keep your market position intact. Access spending power without selling your holdings.',
  },
  {
    icon: Percent,
    title: 'Competitive Rates',
    description: 'Transparent borrowing rates based on on-chain market conditions.',
  },
]

export function CardFeatures() {
  return (
    <section className="py-12 lg:py-20">
      <div className="mx-auto max-w-6xl px-4 lg:px-8 sm:px-6">
        <div className="mb-10 text-center lg:mb-16">
          <Typography variant="h2" className="text-3xl lg:text-4xl" gradient>
            Why HypurrFi Card?
          </Typography>
          <Typography variant="p" className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Use your crypto for real-world spending without selling. No off-ramps, no top-ups.
          </Typography>
        </div>

        <div className="grid gap-4 lg:grid-cols-3 md:grid-cols-2">
          {features.map((feature) => (
            <Panel.Wrapper
              key={feature.title}
              className={cn(
                'group transition-all duration-300',
                'hover:scale-105 hover:border-primary/30',
                'hover:shadow-[0_0_40px_rgba(251,229,114,0.1)]',
              )}
            >
              <Panel.Content className="flex flex-col gap-4 p-6">
                <div
                  className={cn(
                    'flex h-12 w-12 items-center justify-center rounded-lg',
                    'bg-gradient-to-br from-gradient-yellow/20 to-gradient-green/20',
                    'transition-all duration-300 group-hover:from-gradient-yellow/30 group-hover:to-gradient-green/30',
                  )}
                >
                  <feature.icon className="h-5 w-5 text-dim-foreground transition-colors group-hover:text-foreground" />
                </div>
                <Typography variant="h4">{feature.title}</Typography>
                <Typography variant="p" className="text-muted-foreground text-sm">
                  {feature.description}
                </Typography>
              </Panel.Content>
            </Panel.Wrapper>
          ))}
        </div>
      </div>
    </section>
  )
}
